/**
 * @class StoreError A store custom error that is handled and displayed by the error handler
 */
export class StoreError extends Error {
  constructor(message: string) {
    super(message);
  }
}
